import React, { createRef, useContext, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import * as R from 'ramda';
import './AllForBigPicPersonList.scss';
import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';
import FolloweeDetail from '../Followee/FolloweeDetail';
import ShareToast from '../Followee/ShareToast';
import intl from 'react-intl-universal';
import stat from '../../utils/stat';
import { alpha } from '../../utils/color';
import { ThemeContext } from '../../store/ThemeProvider';
import wxUtil, { getQueryShareData } from '../../utils/wx';

interface IAllForBigPicPersonList {
  rootStore?: RootStore;
  personid: string;
  imageid?: string;
  onClose: () => void;
  maybe: any[];
  faceurl?: string;
}

const containerEl = document.createElement('div');
containerEl.setAttribute('id', 'big-pic-person-list');
const AllForBigPicPersonList = function(props: IAllForBigPicPersonList) {
  const { relationStore, wxuserStore, uiStore } = props.rootStore!;
  const [sharePerson, setSharePerson] = useState(0);
  const {
    backgroundColor,
    componentColor,
    mainColor,
    h1Color,
    h2Color
  } = useContext(ThemeContext);
  useEffect(() => {
    document.body.appendChild(containerEl);
    return () => {
      document.body.removeChild(containerEl);
    };
  }, []);

  // 反正都应该先获取一次人物信息，避免看不到头像列表
  useEffect(() => {
    // window.dataDetail && galleryStore.getPersonList(window.dataDetail.id + '', 1);
  }, []);
  const getPerson = (personid: number, imageid?: string, faceurl?: string) => {
    const galleryid =
      (window.dataDetail ? window.dataDetail!.id : window.gallery.id) + '';

    relationStore.getFind(
      galleryid,
      personid,
      imageid ? +imageid : 0,
      undefined,
      faceurl
    );
    return relationStore.getFindPeopleAlbum(galleryid, personid);
  };

  const setCurrentPerson = (id: string, imageid?: string, faceurl?:string) => {
    //setCurrentFollowId(id);
    getPerson(+id, imageid, faceurl);
    stat.event('face_click');
  };

  const { personid, imageid, maybe, faceurl} = props;

  const unfollow = (person: any) => {
    if (wxuserStore.user.is_mock) {
      return wxuserStore.auth();
    }
    uiStore.showToast({ content: intl.get('Processing') });
    wxuserStore.unfollow(person.id).then(() => {
      relationStore.setFindStatus(person.id, 'unfollow');
      uiStore.hideToast();
      uiStore.showToast({ content: intl.get('Unfollow') + intl.get('Success') });
    });
  };

  const follow = (person: any) => {
    if (wxuserStore.user.is_mock) {
      return wxuserStore.auth();
    }
    uiStore.showToast({ content: intl.get('Processing') });
    wxuserStore.follow({
      image: person.faceurl,
      name: person.name,
      personid: person.id,
    }).then(() => {
      relationStore.setFindStatus(person.id, 'follow');
      relationStore.follower();
      uiStore.hideToast();
      uiStore.showToast({ content: intl.get('Follow') + intl.get('Success') });
    }).catch((res: any) => {
      uiStore.hideToast();
      uiStore.showToast({
        content: res && res.code === 2000203
          ? intl.get('MaxFolloweeNum')
          : intl.get('Follow') + intl.get('Failed') + (res && res.messge ? `: ${res.messge}` : ''),
      });
    });
  };

  useEffect(() => {
    if (personid) {
      getPerson(+personid, imageid, faceurl);
    } else {
      relationStore.clearFind();
    }
  }, [personid, imageid, faceurl]);

  useEffect(() => {
    return () => {
      relationStore.clearFind();
    };
  }, []);
  const wrapperEle = createRef<HTMLDivElement>();

  if (!personid) {
    return null;
  }

  return createPortal(
    <div
      className="all-for-big-pic-person-list ignore-move"
      style={{ backgroundColor: alpha(backgroundColor, 1) }}
      ref={wrapperEle}
      onClick={e => e.stopPropagation()}
    >
      <FolloweeDetail
        person={relationStore.find || {}}
        personAlbum={relationStore.findAlbum || []}
        onFollow={follow}
        onUnfollow={unfollow}
        onShowShare={(id: number | string) => setSharePerson(Number(id))}
        onClickPerson={setCurrentPerson}
        disableHistoryRestore={true}
        onBack={() => {
          relationStore.clearFind();
          props.onClose();
        }}
      />
      {!!sharePerson ? (
        <ShareToast
          getDefaultShare={() => {
            const shareQuery = getQueryShareData();
            return wxUtil.configPersonShare(sharePerson, {
              title: shareQuery.t,
              desc: shareQuery.d,
              image: relationStore.find.faceurl,
              avatar: relationStore.find.faceurl,
            });
          }}
          onClose={() => setSharePerson(0)}
          onLinkClick={() => {
            uiStore.showToast({ content: intl.get('Copyed') });
            setSharePerson(0);
          }}
          onEditClick={(options?: any) => {
            wxUtil.configPersonShare(sharePerson, {
              avatar: relationStore.find.faceurl,
              ...R.defaultTo({}, options),
            });
            wxUtil.showShareLimitTip(() => setSharePerson(0));
          }}
        />
      ) : null}
    </div>,
    containerEl
  );
};

export default inject('rootStore')(observer(AllForBigPicPersonList));
